import { z } from 'zod';
import { emailSchema } from './auth.js';
export const addGuardianRequest = z.object({
    email: emailSchema,
    relation: z.string().trim().max(60).optional(),
    canManage: z.boolean().default(true),
    /** optionally link the guardian to their own member record */
    guardianMemberId: z.string().uuid().nullable().optional(),
});
//# sourceMappingURL=guardian.js.map